import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';
import {
  AE_CARD,
  AE_MUTED,
  AE_PUBLIC_PAGE,
  AE_TITLE,
} from '@/components/assessment-engine/layout/aeTheme';
import { assessmentEngineService } from '@/services/assessmentEngineService';

/**
 * Public page from cohort digest email unsubscribe links.
 * Emails use FRONTEND_URL; this page calls the public API.
 */
export const CohortUnsubscribePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { t } = useLanguage();
  const [status, setStatus] = useState<'loading' | 'ok' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!token) {
        setStatus('error');
        return;
      }
      try {
        await assessmentEngineService.unsubscribeCohort(token);
        if (!cancelled) setStatus('ok');
      } catch {
        if (!cancelled) setStatus('error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <main className={AE_PUBLIC_PAGE}>
      <div className={`${AE_CARD} max-w-md mx-auto mt-16 p-6`}>
        {status === 'loading' && <p className={AE_MUTED}>…</p>}
        {status === 'ok' && (
          <>
            <h1 className={AE_TITLE}>{t('assessmentEngine.public.cohortUnsubscribedTitle')}</h1>
            <p className={`mt-3 ${AE_MUTED}`}>{t('assessmentEngine.public.cohortUnsubscribedBody')}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className={AE_TITLE}>{t('assessmentEngine.public.cohortUnsubscribeFailedTitle')}</h1>
            <p className={`mt-3 ${AE_MUTED}`}>{t('assessmentEngine.public.cohortUnsubscribeFailedBody')}</p>
          </>
        )}
      </div>
    </main>
  );
};
